<template>
  <div>
    <common-list
      ref="list"
      url="BizAppSettings/GetList"
      @currentrow="handlerCurrentRow"
      label-position="left"
      label-width="100px"
      :SerchShow="true"
      tableHeight="calc(100vh - 360px)"
    >
      <template v-slot:filter="{ filter }">
        <el-col :span="6">
          <el-form-item label="参数说明">
            <el-input
              v-model="filter.Explain"
              placeholder="参数说明"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="是否启用">
            <el-select v-model="filter.IsUsing" clearable>
              <el-option value="1" label="启用"></el-option>
              <el-option value="0" label="不启用"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:option>
        <el-button type="primary" icon="el-icon-plus" @click="add"
          >添加</el-button
        >
        <el-button type="warning" icon="el-icon-edit" @click="edit"
          >编辑</el-button
        >
        <el-button type="danger" icon="el-icon-delete" @click="deleteItem"
          >删除</el-button
        >
        <!-- v-if="auth('VideoParameterDelete')" -->
      </template>

      <template v-slot:body>
        <el-table-column label="配置编号" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.SettingCode | gang
          }}</template>
        </el-table-column>
        <el-table-column label="参数键名" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.Key | gang }}</template>
        </el-table-column>
        <el-table-column label="参数值" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.Value | gang }}</template>
        </el-table-column>
        <el-table-column label="参数说明" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.Explain }}</template>
        </el-table-column>
        <el-table-column label="是否启用" show-overflow-tooltip>
          <template slot-scope="scope">{{
            scope.row.IsUsing | enumer("IsUsing")
          }}</template>
        </el-table-column>

        <el-table-column label="添加时间" show-overflow-tooltip
          ><template slot-scope="{ row }">
            {{ row.AddTime | datetime("YYYY-MM-DD") }}
          </template></el-table-column
        >
      </template>
    </common-list>
    <!-- 弹出框 -->
    <div>
      <AddEdit :item="itemAddEdit" @success="getData"></AddEdit>
    </div>
  </div>
</template>

<script>
import AddEdit from "./AddEdit";

export default {
  components: {
    AddEdit,
  },
  computed: {},
  data() {
    return {
      DetLines: [],
      itemAddEdit: {},
    };
  },
  watch: {},
  methods: {
    getData() {
      this.$refs.list.getTableData();
    },
    add() {
      let filter = {
        ...this.$refs.list.filter,
      };
      this.itemAddEdit = {
        StaID: filter.StaID,
        DetLineID: filter.DetLineID,
        VideoType: filter.VideoType,
      };
    },
    edit() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.itemAddEdit = {
        SettingCode: this.currentrow.SettingCode,
      };
    },
    deleteItem() {
      if (!this.hasCurrentRow()) {
        return;
      }
      this.$confirm(
        `将删除配置编号为【${this.currentrow.SettingCode}】的数据, 是否继续?`,
        "提示信息",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          cancelButtonClass: "el-button--canale",
          type: "warning",
        }
      )
        .then(() => {
          this.$delete("BizAppSettings/DeleteBizAppSettings", {
            SettingCode: this.currentrow.SettingCode,
          }).then(() => {
            this.$message.success("删除成功");
            this.$refs.list.getTableData();
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style>
</style>